// EVERY HEADER SORTS (owner, 2026-10-22: "i need the shop drawings to reorder
// by all columns headers"). Sorted on what the cell SHOWS, not on the raw
// field: the Hours of a paired drawing is the issue's figure, the Sign-off
// column orders by the date of its star, Status by the workflow, not the
// alphabet. Pure, so the order is tested without the table.
//
// AN EMPTY CELL GOES LAST, BOTH WAYS. A register sorted by Delivered,
// newest first, must open on the newest delivery, not on forty rows that
// say "not delivered".
import { signOffStar } from "./signOffStar";
import { sorterBy, withSorting } from "helpers/tableSort";

const STATUS_ORDER = ["requested", "submitted", "under_review", "rejected", "approved"];
const day = (v) => (v ? String(v).slice(0, 10) : null);
const text = (v) => (v == null || v === "" ? null : String(v));
const num = (v) => (v == null || v === "" || Number.isNaN(Number(v)) ? null : Number(v));

export const SORT_VALUE = {
  name: (r) => text(r.name),
  area: (r) => text(r.area),
  package: (r) => text(r.package),
  requestedAt: (r) => text(r.requestedAt),
  producedBy: (r) => text(r.producedBy),
  deliveredAt: (r) => text(r.deliveredAt),
  responsible: (r) => text((r.responsible || []).map((p) => p.name || p.email).filter(Boolean).join(", ")),
  dueDate: (r) => (r.scheduleMissing ? null : text(r.dueDate)),
  internalRelease: (r) => (r.internalRelease ? text(r.internalRelease.at) || "0" : null),
  signedOff: (r, today) => { const s = signOffStar(r, today); return s ? day(s.date) : null; },
  ownerSignOff: (r) => (r.ownerSignOff ? day(r.ownerSignOff.date) : null),
  status: (r) => { const i = STATUS_ORDER.indexOf(r.status); return i < 0 ? (r.status ? STATUS_ORDER.length : null) : i; },
  openChangeRequests: (r) => num(r.openChangeRequests) || 0,
  directionOutcome: (r) => text(r.directedAt),
  receivedByFieldAt: (r) => text(r.receivedByFieldAt),
  estimatedHours: (r) => num(r.estimatedHours),
  hours: (r) => (r.pairedIssue && r.pairedIssue.hoursOn === "issue" ? num(r.pairedIssue.hours) : num(r.hours)),
};

/** antd compare for one column (helpers/tableSort: empties last both ways). */
export function sorterFor(key, today) {
  const get = SORT_VALUE[key];
  return get ? sorterBy(get, today) : undefined;
}

/** Every column with a sort value gets a sorter; the rest pass through.
 *  `sort` ({ key, order } or null) is the person's remembered sort: the
 *  columns are then CONTROLLED, so the table opens sorted the way they left it. */
export function withSorters(columns, today, sort) {
  return withSorting(columns, SORT_VALUE, sort, today);
}
